import { Link } from "react-router-dom";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageMotherA.module.scss";

function PageMotherA() {
  const getImgSet = useImgSet();

  const item01 = getImgSet("item__01__p13", "png", [s.item, s.item__01]);
  const item02 = getImgSet("item__02__p13", "png", [s.item, s.item__02]);
  const pointer = getImgSet("pointer__mother", "png", s.pointer);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__02", "png", s.img__a);

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>{imgA}</div>
      <div className={s.inner}>
        {item01}
        {item02}
      </div>
      <div className={s.aside_right}>
        <Link to="/mother/" className={s.back}>
          {back}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutOptions(PageMotherA);
